import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/trust.css';

const Trust = () => {
  return (
    <div className="trust-wrapper">
      <div className="trust-header">
        <div className="trust-tab">Trust Center</div>
        <p className="trust-intro">Your privacy and rights matter to us. Explore our policies below:</p>
      </div>

      <div className="trust-tiles">
        <Link to="/donotsell" className="trust-tile">
          <h3>Do Not Sell My Info</h3>
          <p>Learn how we handle your personal data and how to opt-out.</p>
        </Link>

        <Link to="/privacy" className="trust-tile">
          <h3>Privacy Policy</h3>
          <p>Understand how we collect, use, and protect your information.</p>
        </Link>

        <Link to="/terms" className="trust-tile">
          <h3>Terms & Conditions</h3>
          <p>Review the legal agreements and service guidelines.</p>
        </Link>
      </div>
    </div>
  );
};

export default Trust;
